import React, {useContext, useState} from 'react';
import {getMainImage, getModelColorUrl} from '../../../../utils/Model';
import {getBaseImagePath} from "../../../../ui/catalog/Utils";
import {useQuery} from "@tanstack/react-query";
import {getModelColorItems} from "../../../../api/catalog";
import {GlobalContext, ReducerActionType} from "../../../../GlobalReducer";
import useModelColorItem from "../../../../ui/catalog/useModelColorItem";
import Money from '../../../core/Money';
import {EcommerceAction} from "../../../../utils/useDataLayer";
import useDatalayer from "../../../../utils/useDataLayer";
import './BindItems.moduls.scss';

const Binditems = (props) => {
	const {viewMode, params} = props;
	const {articule, selectedColor, text} = params;
	const [state, dispatch] = useContext(GlobalContext);
	const {action: dataLayerManagerAction} = useDatalayer();

	// console.log('Binditem params:', params);

	const {data: modelColorItemsData} = useQuery({
		queryKey: ['modelColorItems', articule],
		queryFn: () => getModelColorItems({
			articules: [articule]
		}),
		staleTime: 0,
		cacheTime: 0
	});

	const {model_color_items: modelColorItems} = modelColorItemsData || {model_color_items: []};

	let selectedColorItem = null;
	if (modelColorItems && modelColorItems.length > 0) {
		selectedColorItem = modelColorItems.find(item => {
			if (item.articul !== articule) return false;
			if (!selectedColor) return true;
			return item.color_special.toLowerCase() === selectedColor.toLowerCase();
		}) || modelColorItems[0];
	}

	if (!selectedColorItem) {
		return null;
	}

	const ProductCard = ({colorItem}) => {
		const image = getMainImage(colorItem);
		const {addToBasket, isExistInBasket, isSizeAvailable} = useModelColorItem(colorItem);

		const handleCardClick = (e) => {
			if (e.target.closest('.card__basket') ||
				e.target.closest('.basket-size') ||
				e.target.closest('.card__img .top .like')) {
				return;
			}
			const url = getModelColorUrl(colorItem);
			window.open(url, '_blank');
		};

		const addToBasketAction = (size) => {
			if (isSizeAvailable(size)) {
				addToBasket(size);
				dataLayerManagerAction(EcommerceAction.ADD_TO_CART, [colorItem]);
			}
		};

		return (
			<div className="landing__bind-item__card card" onClick={handleCardClick}>
				<div className="card__img">
					<picture>
						<img
							src={getBaseImagePath() + image.url}
							alt={colorItem.inetshop_name || ''}
						/>
					</picture>

					<div className="card__basket">
						<p>Добавить в корзину</p>
						<ul className="sizes">
							{colorItem.sizes && colorItem.sizes.map(size => (
								<li key={size}>
									<a
										href="/"
										className={`basket-size ${isExistInBasket(size) ? 'active' : ''} ${!isSizeAvailable(size) ? 'model-size-disabled' : ''} ${size.length > 4 ? 'label-long' : ''}`}
										onClick={(event) => {
											event.preventDefault();
											event.stopPropagation();
											addToBasketAction(size);
										}}
									>
										{size}
									</a>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className="landing__bind-item">
			<div className="landing__bind-item__container">
				<div className="landing__bind-item__product">
					<ProductCard colorItem={selectedColorItem} />
				</div>

				<div className="landing__bind-item__text">
					<div className="landing__bind-item__text-content">
						{text}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Binditems;